import insurancePolicies from './insurancePolicies'

export default { insurancePolicies }
